/**
 * Fallback when Settings has no active `call_outcome` rows (pre-migration / API error).
 * Mirrors backend CallLog::canonicalCallOutcomes() legacy list.
 */
export const LEGACY_CALL_OUTCOME_VALUES: string[] = [
  'FOLLOW UP',
  'KYC COLLETION',
  'NO PROJECT IN HAND',
  'APPROVAL ISSUE',
  'PRODUCT NOT AVAILABLE',
  'NOT RESPONDING',
  'NO SERVICE AREA',
  'MEETING SCHEDULED',
];
